// Картинка заставки мира — без зависимостей от данных мира: её же показывает App, пока скачивается сам экран мира
// (ленивый кусок), — переход «запасной экран → заставка с загрузкой» без скачка. Логика шагов — WorldSplash.
import type { ReactNode } from 'react';
import { t } from '../../i18n/i18n';
import golem from '../../assets/world/art/enemy_guild_boss.webp';
import coin from '../../assets/world/art/cur_gold.webp';
import styles from './WorldSplash.module.css';

export function SplashView({ progress, fading = false, children }: { progress: number; fading?: boolean; children?: ReactNode }) {
  return (
    <div className={`${styles.splash} ${fading ? styles.fade : ''}`} role="status" aria-live="polite" aria-label={t('tg_splash_loading')}>
      <span className={styles.rays} aria-hidden="true" />
      <div className={styles.stage} aria-hidden="true">
        <span className={styles.aura} />
        {Array.from({ length: 12 }, (_, i) => (
          <span key={i} className={styles.spark} style={{ left: `${8 + ((i * 37) % 84)}%`, animationDelay: `${(i * 0.37) % 2.6}s`, animationDuration: `${2.4 + (i % 4) * 0.5}s` }} />
        ))}
        <img className={styles.golem} src={golem} alt="" draggable={false} />
        <span className={styles.shadow} />
      </div>
      <div className={styles.bottom}>
        <span className={styles.title}>{t('tg_splash_loading')}</span>
        <span className={styles.bar}>
          {/* в гнезде рамки — монета крутится, пока грузится */}
          <img className={styles.coin} src={coin} alt="" draggable={false} aria-hidden="true" />
          <span className={styles.fill} style={{ ['--p' as string]: progress.toFixed(3) }} />
        </span>
      </div>
      {children}
    </div>
  );
}
